import AvaliacaoTma from './avaliacao-tma.model';
import avaliacaoTmaService from './avaliacao-tma.service';

export class AvaliacaoTmaStore {
  storageKey = '@AvaliacaoTmaStore';

  current?: any;
  loadind_current = false;

  errors: string[] = [];

  getById = (id: string) => {
    this.current = undefined;
    this.loadind_current = false;
    this.errors = [];

    avaliacaoTmaService.getById(id).then(this.setCurrentSucces).catch(this.setCurrentFailure);
  };

  setCurrentSucces = (value?: AvaliacaoTma) => {
    this.current = value;
    this.loadind_current = false;
  };

  setCurrentFailure = (error: any) => {
    this.current = undefined;
    this.loadind_current = false;
    this.errors = [JSON.stringify(error)];
    console.log(error);
  };
}
